import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { GlobalState } from '../template/app.state';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedPartnerService } from '../services/partner/selectedPartner.service';
import { StateService } from '../services/state/stateService';
import { TOGGLE_LEFT_MENU } from '../state/state';
import { PreloaderService } from '../template/shared/services/preloader/preloader.service';
import { SpinnerService } from '../template/shared/services/spinner/spinner.service';

@Component({
  selector: '.content_inner_wrapper',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent implements OnInit, OnDestroy {
  @ViewChild('leftSidenav2', { static: true }) leftSidenav2: MatSidenav;

  navMode = 'side';
  private _subscriptions: Array<Subscription> = [];
  constructor(private state: GlobalState,
    private _spinner: SpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private selectedPartnerService: SelectedPartnerService,
    private stateService: StateService
  ) {

  }

  ngOnInit() {

    if (window.innerWidth < 992) {
      this.navMode = 'over';
      this.leftSidenav2.opened = false;
    }
    if (window.innerWidth > 992) {
      this.navMode = 'side';
      this.leftSidenav2.open();
    }
    this._subscriptions.push(this.stateService.getStream(TOGGLE_LEFT_MENU).subscribe((t) => this.leftSidenav2.toggle()));
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
      this.navMode = 'over';
      this.leftSidenav2.close();
    }
    if (event.target.innerWidth > 992) {
      this.navMode = 'side';
      this.leftSidenav2.open();
    }
  }

  ngAfterViewInit() {
    PreloaderService.load().then(values => {
      this._spinner.hide();
    });
  }

  toggleIfSmallScreen() {
    if (this.navMode === "over") {
      this.leftSidenav2.toggle();
    }
  }

}